export default "__VITE_ASSET__BmbT81M9__"